import {
  basePost,
  myBasePost
} from "@/utils/request";

// 根据唯一码进行查询
export function getPubgCode(data) {
  return myBasePost("/Finalize/getPubgCode", data);
}

// 在线估值
export function accountValuate(data) {
  return myBasePost("/user/getUserValuation", data);
}


// 定稿功能

// 标题记录
export function getPubgTitle(data) {
  return myBasePost("/Finalize/getPubgTitle", data);
}

// 通行证记录
export function getPubgPass(data) {
  return myBasePost("/Finalize/getPubgPass", data);
}

// 套装记录
export function getPubgSuit(data) {
  return myBasePost("/Finalize/getPubgSuit", data);
}

// 中间商品记录
export function getPubgGoods(data) {
  return myBasePost("/Finalize/getPubgGoods", data);
}

// 小商品记录
export function getPubgBottom(data) {
  return myBasePost("/Finalize/getPubgBottom", data);
}


// 定稿记录
export function getPubgTitleList(data) {
  return myBasePost("/Finalize/getPubgTitleList", data);
}

// 定稿标记
export function getCollectionsRemarks(data) {
  return myBasePost("/Finalize/getCollectionsRemarks", data);
}

// 定稿唯一码
export function getCollectionsCode(data) {
  return myBasePost("/Finalize/getCollectionsCode", data);
}

// 删除定稿记录
export function delPubgTitle(data) {
  return myBasePost("/Finalize/delPubgTitle", data);
}


// 定稿展示

// 缩略图
export function getCollectionsPic(data) {
  return myBasePost("/Finalize/getCollectionsPic", data);
}

// 标题
export function getCollectionsTitle(data) {
  return myBasePost("/Finalize/getCollectionsTitle", data);
}

// 通行证
export function getCollectionsPass(data) {
  return myBasePost("/Finalize/getCollectionsPass", data);
}

// 稀有
export function getCollectionsRareGoods(data) {
  return myBasePost("/Finalize/getCollectionsRareGoods", data);
}

// 套装
export function getCollectionsSuit(data) {
  return myBasePost("/Finalize/getCollectionsSuit", data);
}

// 中间商品
export function getCollectionsGoods(data) {
  return myBasePost("/Finalize/getCollectionsGoods", data);
}

// 小商品
export function getCollectionsBottom(data) {
  return myBasePost("/Finalize/getCollectionsBottom", data);
}


// 微信分享
export function wechatShare(data) {
  return myBasePost("/Finalize/WeChatShare", data);
}